import { CiCalendarDate } from "react-icons/ci";
import { IoTextOutline } from "react-icons/io5";
import { PiSignatureLight } from "react-icons/pi";

const listFields = [
    {
        type: 'sign',
        icon: <PiSignatureLight style={{fontSize: 32}}/>
    },
    {
        type: 'text',
        icon: <IoTextOutline style={{fontSize: 32}}/>
    },
    {
        type: 'date',
        icon: <CiCalendarDate style={{fontSize: 32}}/>
    }
]

export const getIconFieldByType = (type) => listFields.find(({type:fieldType}) => fieldType === type).icon;

export default listFields;